const API_KEY = "AIzaSyCwyUUOSF57wH4fH4OmWx8TEILjoOuAbgE";
const AUTH_DOMAIN = "spaceil-lectures.firebaseapp.com";
const DATABASE_URL = "https://spaceil-lectures-default-rtdb.europe-west1.firebasedatabase.app";
const PROJECT_ID = "spaceil-lectures";
const MESSAGING_SENDER_ID = "1096715716887";
const STORAGE_BUCKET = "spaceil-lectures.appspot.com";
const APP_ID = "1:1096715716887:web:ee7cfe08f511b9528d8f52";
const MEASUREMENT_ID = "G-TTMHBM20JH";

export const environment = {
  production: true,
  firebase: {
    apiKey: API_KEY,
    authDomain: AUTH_DOMAIN,
    databaseURL: DATABASE_URL,
    projectId: PROJECT_ID,
    storageBucket: STORAGE_BUCKET,
    messagingSenderId: MESSAGING_SENDER_ID,
    appId: APP_ID,
    measurementId: MEASUREMENT_ID
  },
  showThemeComponents: false,
  userSessionTimeInMin: 180
};
